import { GORP_MODULE, HH_MODULE, MARKET_MODULE, MFI_MODULE, RPME_MODULE } from "constants/constants"

export interface ModuleRouteConfig {
  moduleId: number
  parentPath: string
  defaultPath: string
}

export const moduleOrder = [MARKET_MODULE, MFI_MODULE, RPME_MODULE, HH_MODULE, GORP_MODULE]

export const moduleRouteConfigs: ModuleRouteConfig[] = [
  { moduleId: MARKET_MODULE, parentPath: "/market-prices", defaultPath: "/market-prices/dashboard" },
  { moduleId: MFI_MODULE, parentPath: "/mfi", defaultPath: "/mfi/surveys" },
  { moduleId: RPME_MODULE, parentPath: "/rpme", defaultPath: "/rpme/surveys" },
  { moduleId: HH_MODULE, parentPath: "/household", defaultPath: "/household/surveys" },
  { moduleId: GORP_MODULE, parentPath: "/gorp", defaultPath: "/gorp/gorpReports" },
]

export const getModulePath = (moduleId: number): string | null =>
  moduleRouteConfigs.find(config => config.moduleId === moduleId)?.defaultPath || null
